import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-log-out-icon lucide-log-out",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m16 17 5-5-5-5" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 12H9" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" })
	]
});
export default SvgLogOut;
